import { render, staticRenderFns } from "./InvestorDetail.vue?vue&type=template&id=7eef6661"
import script from "./InvestorDetail.vue?vue&type=script&lang=js"
export * from "./InvestorDetail.vue?vue&type=script&lang=js"
import style0 from "./InvestorDetail.vue?vue&type=style&index=0&id=7eef6661&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports